import React from 'react';
import { StarIcon, PlayIcon, LightbulbIcon, Share2Icon, HeartIcon, MessageCircleIcon, CheckIcon } from 'lucide-react';
export function TemplateFormLongPage() {
  return <div className="min-h-screen w-full bg-[#f8f7f4] font-sans text-[#1e293b] selection:bg-[#b91c1c] selection:text-white" data-id="element-1219">
      {/* 1. Top Nav Bar - 3 Column Layout */}
      <header className="bg-[#002868] text-white w-full py-3" data-id="element-1220">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-row items-center justify-between gap-2 sm:gap-4" data-id="element-1221">
          {/* Left: Logo */}
          <div className="flex items-center gap-1.5 sm:gap-2 font-bold text-base sm:text-xl tracking-tight" data-id="element-1222">
            <StarIcon className="w-5 h-5 sm:w-6 sm:h-6 fill-current text-[#b91c1c]" data-id="element-1223" />
            <span data-id="element-1224">PatriotsInformer News</span>
          </div>

          {/* Right: Get Started Button */}
          <div className="flex-shrink-0" data-id="element-1225">
            <button className="px-3 sm:px-4 py-1.5 border border-white rounded text-xs sm:text-sm font-semibold hover:bg-white hover:text-[#002868] transition-colors whitespace-nowrap" data-id="element-1226">
              Get Started »
            </button>
          </div>
        </div>
      </header>

      {/* Main Content Container */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8 sm:py-12" data-id="element-1227">
        {/* 2. Author Bio Section */}
        <div className="flex flex-row items-center gap-4 sm:gap-6 max-w-3xl mx-auto mb-12" data-id="element-1228">
          <img src="https://cdn.magicpatterns.com/uploads/qCiNdfGtT6ARUfiGnS7VJm/jack-turner-avatar-2.jpg" alt="Author" className="w-16 h-16 sm:w-20 sm:h-20 rounded-full object-cover border-2 border-gray-200 shadow-sm flex-shrink-0" data-id="element-1229" />
          <div className="text-left space-y-1" data-id="element-1230">
            <h3 className="font-bold text-[#0f172a] text-lg" data-id="element-1231">Jack Turner</h3>
            <p className="text-gray-500 text-sm" data-id="element-1232">
              Head of research at PatriotsInformer.com
            </p>
            <p className="text-gray-400 text-xs uppercase tracking-wide pt-1" data-id="element-1233">
              September 24, 2025 · 4 min read
            </p>
          </div>
        </div>

        <div className="flex flex-col lg:flex-row gap-12 relative" data-id="element-1234">
          {/* 1. Social Share Sidebar (Desktop Sticky) */}
          <aside className="hidden lg:flex flex-col gap-6 sticky top-8 h-fit w-16 items-center pt-8 text-gray-400" data-id="element-1235">
            <div className="flex flex-col items-center gap-1 cursor-pointer hover:text-[#b91c1c] transition-colors group" data-id="element-1236">
              <div className="w-10 h-10 rounded-full border border-gray-200 flex items-center justify-center bg-white shadow-sm group-hover:border-[#b91c1c]" data-id="element-1237">
                <Share2Icon className="w-5 h-5" data-id="element-1238" />
              </div>
              <span className="text-xs font-medium" data-id="element-1239">Share</span>
            </div>
            <div className="flex flex-col items-center gap-1 cursor-pointer hover:text-[#b91c1c] transition-colors group" data-id="element-1240">
              <div className="w-10 h-10 rounded-full border border-gray-200 flex items-center justify-center bg-white shadow-sm group-hover:border-[#b91c1c]" data-id="element-1241">
                <HeartIcon className="w-5 h-5" data-id="element-1242" />
              </div>
              <span className="text-xs font-medium" data-id="element-1243">124</span>
            </div>
            <div className="flex flex-col items-center gap-1 cursor-pointer hover:text-[#b91c1c] transition-colors group" data-id="element-1244">
              <div className="w-10 h-10 rounded-full border border-gray-200 flex items-center justify-center bg-white shadow-sm group-hover:border-[#b91c1c]" data-id="element-1245">
                <MessageCircleIcon className="w-5 h-5" data-id="element-1246" />
              </div>
              <span className="text-xs font-medium" data-id="element-1247">42</span>
            </div>
          </aside>

          {/* Main Article Content */}
          <article className="flex-1 max-w-3xl mx-auto space-y-10" data-id="element-1248">
            {/* Headline & Subtitle */}
            <div className="space-y-6 text-center sm:text-left" data-id="element-1249">
              <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-[#0f172a] tracking-tight leading-tight" data-id="element-1250">
                How to Secure Your Water Supply Fast WITHOUT Drilling a Single
                Well!
              </h1>
              <div className="space-y-4" data-id="element-1251">
                <p className="text-xl sm:text-2xl text-gray-500 font-light leading-relaxed" data-id="element-1252">
                  This works even if your property is BRAND NEW!
                </p>
                <p className="text-xl sm:text-2xl text-gray-500 font-light leading-relaxed" style={{
                marginTop: '0px'
              }} data-id="element-1253">
                  Watch the video now...
                </p>
              </div>
            </div>

            {/* Video Placeholder */}
            <div className="relative w-full aspect-video bg-black rounded-lg overflow-hidden shadow-xl group cursor-pointer" data-id="element-1254">
              <img src="https://images.unsplash.com/photo-1538300342682-cf57afb97285?q=80&w=2574&auto=format&fit=crop" alt="Video thumbnail" className="w-full h-full object-cover opacity-80 group-hover:opacity-60 transition-opacity" data-id="element-1255" />
              <div className="absolute inset-0 flex items-center justify-center" data-id="element-1256">
                <div className="w-20 h-20 bg-[#b91c1c] rounded-xl flex items-center justify-center shadow-2xl group-hover:scale-110 transition-transform duration-300" data-id="element-1257">
                  <PlayIcon className="w-10 h-10 text-white fill-current ml-1" data-id="element-1258" />
                </div>
              </div>
              <div className="absolute bottom-4 left-4 bg-black/70 px-3 py-1 rounded text-white text-sm font-medium flex items-center gap-2" data-id="element-1259">
                <span className="w-2 h-2 bg-red-500 rounded-full animate-pulse" data-id="element-1260"></span>
                Watch Now
              </div>
            </div>

            {/* 2. Opening Paragraphs */}
            <div className="space-y-6 text-lg text-[#334155] leading-relaxed" data-id="element-1261">
              <p className="font-medium text-[#0f172a]" data-id="element-1262">
                Alright, let's get right to it here...
              </p>
              <p data-id="element-1263">
                As you saw in the video, you now know how you can secure 100% of
                your family's water needs without drilling a single well
                yourself... and without waiting 6-12 months for a drilling
                company to show up. This is the fastest way to get a reliable,
                off-grid water source off the ground—hands down.
              </p>
              <p className="italic font-medium text-[#0f172a]" data-id="element-1264">
                And the best part?
              </p>
              <p data-id="element-1265">
                It works straight from any rain barrel, nearby creek, or even a
                murky pond—the original survival water source.
              </p>
              <p data-id="element-1266">Let's recap...</p>
            </div>

            {/* 3. Section Heading */}
            <div className="space-y-6" data-id="element-1267">
              <h2 className="text-2xl sm:text-3xl font-bold text-[#0f172a] text-center" data-id="element-1268">
                It All Starts With a Simple Filtration System...
              </h2>
              <div className="space-y-6 text-lg text-[#334155] leading-relaxed" data-id="element-1269">
                <p data-id="element-1270">
                  We call our special DIY Bio-Filter the{' '}
                  <span className="font-bold text-[#b91c1c]" data-id="element-1271">
                    "Endless Spring"
                  </span>{' '}
                  because it delivers pure water day after day, just like a
                  natural spring.
                </p>
                <p data-id="element-1272">
                  They showed us in four big buckets delivered right to his door
                  by UPS. Each bucket had the layers of sand and gravel, and he
                  paid about $15 per bucket, shipping included.
                </p>
                <p className="font-bold text-[#0f172a]" data-id="element-1273">
                  Let me say that again.
                  <br data-id="element-1274" />
                  $15 per bucket.
                  <br data-id="element-1275" />
                  That's wild!
                </p>
                <p data-id="element-1276">
                  They were grown in a stack of common 5-gallon buckets you can
                  get at any hardware store. But come SHTF, when the taps run
                  dry... they'll turn that "dirty" water into a lifesaver.
                </p>
              </div>
            </div>

            {/* 4. CTA Callout Box */}
            <div className="border-4 border-dashed border-[#b91c1c] bg-yellow-50 p-6 sm:p-8 rounded-lg relative" data-id="element-1277">
              <div className="space-y-4" data-id="element-1278">
                <div className="flex items-start gap-3" data-id="element-1279">
                  <LightbulbIcon className="w-6 h-6 text-yellow-600 fill-current flex-shrink-0 mt-1" data-id="element-1280" />
                  <h3 className="text-xl font-bold text-[#0f172a]" data-id="element-1281">
                    Wanna know exactly where we get these materials for dirt
                    cheap?
                  </h3>
                </div>

                <p className="text-[#334155] text-lg leading-relaxed pl-9" style={{
                paddingLeft: '5px'
              }} data-id="element-1282">
                  We've packed all of our best sourcing secrets—including the
                  exact sand grades and gravel types—inside our DIY Biosand
                  System guide.
                </p>

                <div className="pl-9 pt-2" style={{
                paddingLeft: '5px'
              }} data-id="element-1283">
                  <a href="#" className="inline-flex items-center gap-2 text-[#002868] font-bold text-xl hover:underline decoration-2 underline-offset-4" data-id="element-1284">
                    Click here to learn more »
                  </a>
                </div>
              </div>
            </div>

            {/* 5. Divider */}
            <hr className="border-t-2 border-[#b91c1c] opacity-20 my-8" data-id="element-1285" />

            {/* 6. The Numbers Section */}
            <div className="space-y-6" data-id="element-1286">
              <h2 className="text-2xl sm:text-3xl font-bold text-[#0f172a] text-center" data-id="element-1287">
                The Numbers That Make This Work
              </h2>
              <div className="space-y-6 text-lg text-[#334155] leading-relaxed" data-id="element-1288">
                <p data-id="element-1289">Let's say you only build 2 filters, just to start small.</p>
                <ul className="list-disc pl-6 space-y-2 marker:text-[#b91c1c]" data-id="element-1290">
                  <li data-id="element-1291">Your cost? 2 buckets x $15 = $30</li>
                  <li data-id="element-1292">Output? 40 gallons of clean water per day.</li>
                  <li data-id="element-1293">That's 1200 gallons a month from a $30 investment.</li>
                  <li data-id="element-1294">
                    Do it five times... and you've turned $150 into a community
                    water hub.
                  </li>
                </ul>
                <p className="font-bold text-[#0f172a]" data-id="element-1295">
                  That's a massive return on investment, and you didn't drill a
                  single hole yourself.
                </p>
                <p data-id="element-1296">
                  And if you've got ambitious neighbors?
                  <br data-id="element-1297" />
                  Let them use it for a small barter fee.
                  <br data-id="element-1298" />
                  Wait two years and you're looking at serious trading power.
                </p>
                <p className="italic" data-id="element-1299">
                  This is how backyard fortunes quietly stack serious profits.
                </p>
              </div>
            </div>

            {/* 7. Special Equipment Section */}
            <div className="space-y-6" data-id="element-1300">
              <h2 className="text-2xl sm:text-3xl font-bold text-[#0f172a] text-center" data-id="element-1301">
                You Don't Need Special Equipment
              </h2>
              <div className="space-y-6 text-lg text-[#334155] leading-relaxed" data-id="element-1302">
                <p data-id="element-1303">
                  My dad told me about a customer of his who lives in a mobile
                  home park. She doesn't have a ton of space, but she's having
                  the time of her life purifying water for her garden. It's
                  right on her porch, and when people find out she has "magic
                  water"... they can't stop showing up.
                </p>
                <p className="italic font-medium text-[#0f172a]" data-id="element-1304">
                  People NEED clean water.
                </p>
                <p data-id="element-1305">
                  And when you've got something reliable, like these filters...
                  they basically sell themselves.
                </p>
                <p data-id="element-1306">
                  He even said his doctor started grilling him about what he
                  drinks when she saw his bloodwork. That's the kind of interest
                  you'll get just by mentioning what you do.
                </p>
              </div>
            </div>

            {/* 8. Bonus Tip Callout - Matching CTA Callout Box Style */}
            <div className="border-4 border-dashed border-[#b91c1c] bg-yellow-50 p-6 sm:p-8 rounded-lg relative" data-id="element-1307">
              <div className="space-y-4" data-id="element-1308">
                <div className="flex items-start gap-3" data-id="element-1309">
                  <h3 className="text-xl font-bold text-[#0f172a]" data-id="element-1310">
                    <span data-id="element-1311">🎁</span> Bonus Tip:
                  </h3>
                </div>

                <p className="text-[#334155] text-lg leading-relaxed pl-9" style={{
                paddingLeft: '5px'
              }} data-id="element-1312">
                  If you want to skip the years of trial and error—and get the
                  full blueprint for starting a profitable water setup—we've got
                  you covered.
                </p>
                <p className="text-[#334155] text-lg leading-relaxed pl-9" style={{
                paddingLeft: '5px'
              }} data-id="element-1313">
                  Our <span className="font-bold" data-id="element-1314">Backyard Growing System</span>{' '}
                  walks you through the entire process AND includes our{' '}
                  <span className="font-bold" data-id="element-1315">Secret Wholesale Directory</span>{' '}
                  with all our best sources for starter parts, tanks, and
                  valves.
                </p>
                <p className="italic text-sm text-gray-500 pl-9" style={{
                paddingLeft: '5px'
              }} data-id="element-1316">
                  "These aren't public hardware catalogs... these are
                  underground growers only realize we've built over decades."
                </p>

                <div className="pl-9 pt-2" style={{
                paddingLeft: '5px'
              }} data-id="element-1317">
                  <a href="#" className="inline-flex items-center gap-2 text-[#002868] font-bold text-xl hover:underline decoration-2 underline-offset-4" data-id="element-1318">
                    <span className="text-2xl" data-id="element-1319">👉</span>
                    Check it out here before prices go up »
                  </a>
                </div>
              </div>
            </div>

            {/* 9. Why This Works Section */}
            <div className="space-y-6" data-id="element-1320">
              <h2 className="text-2xl sm:text-3xl font-bold text-[#0f172a] text-center" data-id="element-1321">
                Here's Why This Works So Well:
              </h2>
              <ol className="space-y-6 text-lg text-[#334155] leading-relaxed list-decimal pl-6 marker:text-[#b91c1c] marker:font-bold" data-id="element-1322">
                <li data-id="element-1323">
                  <span className="font-bold text-[#0f172a]" data-id="element-1324">
                    You're not starting from scratch
                  </span>{' '}
                  — you're skipping YEARS of guessing time and jumping straight
                  to profit.
                </li>
                <li data-id="element-1325">
                  <span className="font-bold text-[#0f172a]" data-id="element-1326">
                    You're not babysitting fragile systems
                  </span>{' '}
                  — these come with good biological layers and don't even know
                  they've been moved when you put them up.
                </li>
                <li data-id="element-1327">
                  <span className="font-bold text-[#0f172a]" data-id="element-1328">
                    You don't need acres
                  </span>{' '}
                  — you could start with 25 or 50 buckets tucked behind your
                  garage or patio.
                </li>
                <li data-id="element-1329">
                  <span className="font-bold text-[#0f172a]" data-id="element-1330">
                    Water doesn't sit around long
                  </span>{' '}
                  — as soon as people know you've got something good, they want
                  it.
                </li>
              </ol>
            </div>

            {/* 10. What to Do Next Section */}
            <div className="space-y-8" data-id="element-1331">
              <h2 className="text-2xl sm:text-3xl font-bold text-[#0f172a] text-center" data-id="element-1332">
                What to Do Next
              </h2>
              <div className="space-y-6 text-lg text-[#334155] leading-relaxed" data-id="element-1333">
                <p data-id="element-1334">
                  If you want to try this for yourself, here's what I recommend:
                </p>
                <ul className="space-y-3 pl-6" data-id="element-1335">
                  <li className="flex items-start gap-3" data-id="element-1336">
                    <div className="mt-1.5 w-1.5 h-1.5 rounded-full bg-[#b91c1c] flex-shrink-0" data-id="element-1337" />
                    <span data-id="element-1338">Start small. 2-5 buckets is plenty.</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-1339">
                    <div className="mt-1.5 w-1.5 h-1.5 rounded-full bg-[#b91c1c] flex-shrink-0" data-id="element-1340" />
                    <span data-id="element-1341">
                      Pot them up or put them in a shed about 4 inches apart.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-1342">
                    <div className="mt-1.5 w-1.5 h-1.5 rounded-full bg-[#b91c1c] flex-shrink-0" data-id="element-1343" />
                    <span data-id="element-1344">
                      Share pics of your setup online or with local prepper
                      groups.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-1345">
                    <div className="mt-1.5 w-1.5 h-1.5 rounded-full bg-[#b91c1c] flex-shrink-0" data-id="element-1346" />
                    <span data-id="element-1347">Watch how fast they go.</span>
                  </li>
                </ul>
                <p data-id="element-1348">
                  And like I said... if you want a reliable place to get started
                  cheap...
                  <br data-id="element-1349" />
                  We've already done the hard work for you &nbsp;
                  <a href="#" className="text-[#002868] font-bold underline hover:text-[#b91c1c]" data-id="element-1350">
                    click here for instant access.
                  </a>
                </p>
                <p data-id="element-1351">
                  This is hands-down one of the easiest ways to get into the
                  backyard survival game, and it's crazy profitable if you stick
                  with it.
                </p>

                <div className="pt-8 space-y-2" data-id="element-1352">
                  <p className="text-lg font-medium text-[#0f172a]" data-id="element-1353">
                    Learn. Build. Be ready.
                  </p>
                  <img src="https://cdn.magicpatterns.com/uploads/iK7Ls4uTvRReaehp29Hcev/JackTurnerSigntature.png" alt="Jack Turner Signature" className="h-28 py-2" data-id="element-1354" />
                  <p className="text-sm font-bold text-[#0f172a] uppercase tracking-wide" data-id="element-1355">
                    Jack Turner
                  </p>
                </div>
              </div>
            </div>
          </article>
        </div>
      </div>

      {/* Footer - Reusing style */}
      <footer className="bg-white border-t border-gray-200 mt-12 py-12" data-id="element-1356">
        <div className="max-w-4xl mx-auto px-4 text-center space-y-6" data-id="element-1357">
          <div className="flex items-center justify-center gap-2 text-[#b91c1c]" data-id="element-1358">
            {/* Simple Logo Graphic */}
            <div className="relative w-10 h-10" data-id="element-1359">
              <StarIcon className="w-10 h-10 fill-current text-[#002868]" data-id="element-1360" />
              <StarIcon className="w-4 h-4 fill-current text-white absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" data-id="element-1361" />
            </div>
          </div>

          <div className="text-xs text-gray-500 space-y-4 max-w-2xl mx-auto leading-relaxed" data-id="element-1362">
            <p data-id="element-1363">
              © 2018-2026 PatriotsInformer Media, LLC | All Rights Reserved |
              10160 Highway 242 Ste 800 PMB 1089, Conroe, TX 77385
            </p>
            <p className="space-x-2" data-id="element-1364">
              <a href="#" className="underline hover:text-[#002868]" data-id="element-1365">
                Terms & Conditions
              </a>
              <span data-id="element-1366">|</span>
              <a href="#" className="underline hover:text-[#002868]" data-id="element-1367">
                Privacy Policy
              </a>
              <span data-id="element-1368">|</span>
              <a href="#" className="underline hover:text-[#002868]" data-id="element-1369">
                Contact Us
              </a>
            </p>
            <p data-id="element-1370">
              No part of this report may be reproduced or placed on any
              electronic medium without written permission from the publisher.
              Information contained herein is obtained from sources believed to
              be reliable, but its accuracy cannot be guaranteed.
            </p>
          </div>
        </div>
      </footer>
    </div>;
}